module.exports = __webpack_public_path__ + "img/quhua.11fb3659.png";